// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UGkdz","colBig":"styles_colBig__j86-r","colSmall":"styles_colSmall__1_MLL"};